<div class="main-content">
  <!-- style="background-color: gray;" -->
  <div class="container-fluid">
    <h1 class="h1__title text-center"><strong>COURIER & BEYOND</strong></h1>
    <br>
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-9 col-xl-9 m-auto">
        <div class="row">
          <div class="col-12 text-center">
            <label class="label__title"
              ><strong>We courier and go beyond</strong></label
            >
          </div>
          <div class="col-12 text-center">
            <!-- <br />
            <label class="label__title"
              ><strong>We courier and go beyond</strong></label
            > -->
            <!-- <h3 class="mt-5"><strong>We courier and go beyond</strong></h3> -->
            <img
              class="img"
              src="../../../assets/img/logoCompany.jpeg"
              alt=""
            />
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="card card__ourstory">
              <div class="card-header text-center">
                <label class="label__title"><strong>Our Story</strong></label>
              </div>
              <div class="card-body">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <!-- <label class="bmd-label-floating" for="name"
                    >Description</label
                  > -->
                      <p>
                        Born on August 7, 2020, Courier & Beyond emerged not as
                        a logistics solution, but as a statement — a new
                        standard for same-day courier shaped by elegance, speed,
                        and technological clarity. It began as a response to the
                        urgency of modern life, for those who move with
                        precision and expect their world to follow suit. From
                        day one, we have designed for the discerning,
                        transforming deliveries and task execution into a
                        seamless extension of personal rhythm. What started as
                        necessity evolved into architecture — intelligent,
                        intuitive, and destined to move ahead of its time.
                        Founded by Juan Garcia & Paul Garcia Visionaries shaping
                        immediacy with precision and grace since 2020.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-6">
            <div class="card card__mision">
              <div class="card-body">
                <div class="text-center">
                  <label class="label__title"><strong>Mission</strong></label>
                </div>
                <div class="form-group">
                  <p>
                    Courier & Beyond delivers a harmonized experience where
                    intelligent systems, refined human instinct, and
                    technological fluency converge. Our platform empowers
                    high-end same-day delivery and tailored task execution,
                    serving individuals and enterprises who require precision
                    without hesitation. Each request is treated as an extension
                    of identity — crafted, anticipated, and fulfilled through a
                    seamless orchestration of digital infrastructure and
                    personalized coordination. We move with intention, elegance,
                    and a deep understanding of time as luxury. This is service
                    elevated to ritual, where every moment is met with
                    exactitude.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6">
            <div class="card card__mision">
              <div class="card-body">
                <div class="text-center">
                  <label class="label__title"><strong>Vision</strong></label>
                </div>
                <div class="form-group">
                  <p>
                    We envision a future where logistics dissolves into
                    experience — adaptive, invisible, exquisitely responsive. As
                    technology evolves, so do we, designing within its unfolding
                    rhythm and building structures that intuit needs before they
                    arise. Courier & Beyond exists in constant refinement,
                    aligning itself with innovation not as a trend, but as a
                    medium for elegant problem-solving. We are architects of
                    immediacy, cultivating a platform that grows alongside the
                    tempo of tomorrow’s most discerning lives. In every
                    iteration, we remain devoted to creating systems that feel
                    less like operations and more like instinct realized.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mt-5">
          <div class="col-6 text-center">
            <!-- <h3>Your cut-to-fit courier</h3> -->
            <label class="label__title"
              ><strong>Your cut-to-fit courier</strong></label
            >
          </div>
          <div class="col-6 text-center">
            <!-- <h3>Your cut-to-fit courier</h3> -->
            <label class="label__title"
              ><strong>I do things for you</strong></label
            >
          </div>
          <div class="col-6 text-center">
            <img
              class="img-fluid img2"
              src="../../../assets/img/courierCar.jpg"
              alt="car"
            />
          </div>
          <div class="col-6 text-center">
            <img
              class="img-fluid img2"
              src="../../../assets/img/courierCar2.jpg"
              alt="car2"
            />
          </div>
        </div>

        <div class="row d-flex align-items-stretch">
          <div class="col-6 d-flex">
            <div class="card card__mision flex-fill">
              <div class="card-body">
                <div class="text-center">
                  <label class="label__title"><strong>Courier</strong></label>
                </div>
                <div class="form-group">
                  <p>
                    Our Same-Day Courier Service is designed for the luxury
                    market — a VIP solution that goes far beyond standard
                    delivery. We specialize in cut-to-fit courier services,
                    tailored with precision, discretion, and unwavering
                    reliability, ensuring that every item arrives exactly as
                    promised, no matter the circumstance.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="col-6 d-flex">
            <div class="card card__mision flex-fill">
              <div class="card-body">
                <div class="text-center">
                  <label class="label__title"><strong>Runners</strong></label>
                </div>
                <div class="form-group">
                  <p>
                    A Task Runner is a highly trained professional who acts as a
                    trusted extension of the client, capable of handling
                    anything from personal errands to complex corporate tasks
                    with discretion and precision. It’s a flexible, luxury-level
                    service that delivers intelligent solutions on demand.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card card__mision mb-0 mt-0">
              <div class="card-body">
                <div class="text-center">
                  <label class="label__title"
                    ><strong>Technology Stack</strong></label
                  >
                </div>
                <div class="form-group">
                  <ul class="list-unstyled">
                    <li><strong>Website:</strong> WordPress</li>
                    <li><strong>Mobile Apps:</strong> Ionic Framework</li>
                    <li>
                      <strong>Dashboard:</strong> Plantilla de Creative Tim
                      (Angular)
                    </li>
                    <li><strong>Integraciones:</strong> IA</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12">
            <div class="card card__mision">
              <div class="card-body">
                <div class="text-center">
                  <label class="label__title"
                    ><strong>Infrastructure</strong></label
                  >
                </div>
                <div class="form-group mt-4">
                  <ul class="list-unstyled">
                    <li>
                      <strong>Hosting / Servidores:</strong> Bluehost,
                      DigitalOcean
                    </li>
                    <li><strong>Bases de datos:</strong> MongoDB</li>
                    <li>
                      <strong>Seguridad:</strong>
                      <ul>
                        <li>
                          Aplicaciones móviles y web, con dashboard seguro
                        </li>
                        <li>
                          Autenticación con <code>JWT</code> en el backend
                        </li>
                        <li>
                          Doble factor de autenticación en el ingreso a la
                          plataforma
                        </li>
                        <li>
                          Certificado SSL para la web y conexiones cifradas
                        </li>
                        <li>Llaves SSH en el servidor para accesos</li>
                        <li>
                          Llaves SSH también para acciones en repositorios
                        </li>
                        <li>
                          Copias de seguridad de la base de datos:
                          <ul>
                            <li>En el servidor</li>
                            <li>
                              En Google Drive (fuente adicional de respaldo)
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-12 text-center">
            <a
              class="a"
              [href]="wForm"
              target="_blank"
              rel="noopener noreferrer"
              >W9 Form
            </a>
            <a class="a" [href]="doc" target="_blank" rel="noopener noreferrer"
              >Print</a
            >
            <a
              class="a"
              [href]="EInNumber"
              target="_blank"
              rel="noopener noreferrer"
              >EInNumber</a
            >
            <a
              class="a"
              [href]="corpPaper"
              target="_blank"
              rel="noopener noreferrer"
              >Corp Paper</a
            >
          </div>
        </div>
        <br />

        <div class="d-flex justify-content-center div-links">
          <label class="mr-1 label" for=""
            >https://driver.courierandbeyond.com/</label
          >
          -
          <label class="mr-1 ml-2 label" for=""
            >https://customer.courierandbeyond.com/</label
          >
          -
          <label class="ml-2 label" for=""
            >https://back.courierandbeyond.com/register</label
          >
          <label class="ml-2 label" for=""
            >https://back.courierandbeyond.com/visitor</label
          >
        </div>
      </div>
    </div>
  </div>
</div>
